import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-activation-code-modal',
  imports: [
    TranslateModule
  ],
  templateUrl: './activation-code-modal.component.html',
  styleUrl: './activation-code-modal.component.scss'
})
export class ActivationCodeModalComponent {
  private dialog = inject(MatDialogRef<any>);
  public data = inject(MAT_DIALOG_DATA);

  ngOnInit(): void {
    document.body.classList.add('modal-open');
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      appRoot.removeAttribute('aria-hidden');
    }
  }

  ngOnDestroy() {
    document.body.classList.remove('modal-open');
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      appRoot.setAttribute('aria-hidden', 'true');
    }
  }

  beforeClose() {
    if (document.body.classList.contains('modal-open')) {
      document.body.classList.remove('modal-open');
    }
  }

  closeDialog(res?: any): void {
    this.beforeClose();
    this.dialog.close(res);
  }
}
